module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_cloud-f3ec9f12736fb0acd622787ad18914b1.svg";